import PropTypes from 'prop-types';

import styles from './_index.module.scss';

const FastTrackLoadingDots = ({ topics }) => {
  return (
    <div className={styles['fast-track-loading-dots']}>
      {topics.map((topic, index) => {
        return (
          <div
            className={`${styles['fast-track-loading-dot']} ${topic.status === 'COMPLETED' ? styles['is-complete'] : ''}`}
            key={index}
          />
        );
      })}
    </div>
  );
};

FastTrackLoadingDots.propTypes = {
  topics: PropTypes.array.isRequired,
};

export default FastTrackLoadingDots;
